import type { NotFoundPageDE } from "../de/de.notFoundPage";

export const NotFoundPageEN: typeof NotFoundPageDE = {
  title: "Page disappeared, it is.",
  subtitle:
    "Chosen the wrong URL, you have, young Padawan. Find the path to the right page, you must.",
  button: "Back to the start page",
};
